import React, { useContext } from 'react';
import loadable from '@loadable/component';
import styled from 'styled-components';
import Dialog from '../Dialog';
import { MODALS } from '../../constants';
import { Context } from '../../context/AppContext';

const WelcomeSuccessContent = loadable(() => import('./WelcomeSuccesContent'));

const StyledDialog = styled(Dialog)`
  @media (max-width: 767px) {
    max-height: 100vh;
  }
`;

const WelcomeSuccessModal = () => {
  const {
    modal: { hideModal, modals },
  } = useContext(Context);

  const modalName = MODALS.WELCOME_SUCCESS;

  const { show } = modals[modalName] || {};

  return (
    <StyledDialog
      maxWidth="620px"
      show={show}
      clickOutside
      onDialogFormClose={() => hideModal(modalName)}
      onClose={() => hideModal(modalName)}
    >
      <WelcomeSuccessContent />
    </StyledDialog>
  );
};

export default WelcomeSuccessModal;
